import { ApiClient } from '@travel/api-client';
import { TaxFeeTypes } from 'TaxFeeTypes-Types';

export const ApiFetchTaxFeeTypes = (http: ApiClient): Promise<TaxFeeTypes[]> => {
  return http.get('/provider-api/extranet/external/providers/taxFeeTypes', {});
};
